import React, { useEffect } from 'react';
import { Textfit } from 'react-textfit';
import { withStyles } from '@material-ui/core/styles';
import config from '../../config';
import get from 'lodash/get';
import { Storage } from 'aws-amplify';
import { shuffleArray } from '../../common/modules.js';
import { useKey } from 'react-use';

const styles = theme => ({
  root: {
    display: 'grid',
    height: '100%',
    padding: 10,
    gridTemplateRows: 'repeat(2, 1fr)',
    margin: '0px 50px',
  },
  quote: {
    gridRow: '2 / 3',
    color: 'white',
    placeSelf: 'center',
    textAlign: 'center',
  },
  logo: {
    justifySelf: 'center',
  },
});

const Screensaver = ({ classes }) => {
  const [quotes, setQuotes] = React.useState([]);
  const [currentQuote, setCurrentQuote] = React.useState(0);
  useKey(
    e => e.key === 'z',
    () => setCurrentQuote(prev => (prev + 1 >= quotes.length ? 0 : prev + 1)),
    { event: 'keydown' },
    [currentQuote, quotes],
  );

  const nextQuote = () => {
    if (currentQuote < quotes.length - 1) {
      setCurrentQuote(prevQuote => prevQuote + 1);
    } else {
      setCurrentQuote(0);
    }
  };

  const getAllQuotes = async () => {
    try {
      const s3Response = await Storage.get('quotes.json');
      const response = await fetch(s3Response);
      const parsedJson = await response.json();
      console.log('SUCCESS ', parsedJson);
      setQuotes(shuffleArray(parsedJson.filter(q => q.approved)));
    } catch (e) {
      console.log('FAIL ', e);
    }
  };

  useEffect(() => {
    getAllQuotes();
  }, []);

  useEffect(() => {
    const timerId = setInterval(() => {
      nextQuote();
    }, 60e3);

    return () => {
      clearInterval(timerId);
    };
  });

  return (
    <div className={classes.root}>
      <div className={classes.logo}>
        <img height={400} src={config.logoUrl} />
      </div>
      <Textfit data-testid="quote" min={30} className={classes.quote}>
        {get(quotes[currentQuote], 'content', '...')}
      </Textfit>
    </div>
  );
};

export default withStyles(styles)(Screensaver);
